export default "__VITE_ASSET__00135782__"